/* eslint-disable max-len */
import React from "react"
import styled from "styled-components"

import BaseSvgIcon from "./Base"

const Sort = (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 20.33 15.1" {...props}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g id="Sort" stroke="#3D3D35" strokeWidth="1.3">
          <polyline id="Path" points="0.65 3 3 0.65 5.3 2.96" />
          <polyline id="Path" points="5.3 12.1 2.96 14.45 0.65 12.14" />
          <path d="M8.86,1.62 L19.54,1.62" id="Path" />
          <path d="M8.86,5.5 L17.19,5.5" id="Path" />
          <path d="M8.86,13.28 L16.26,13.28" id="Path" />
          <path d="M8.86,9.39 L19.68,9.39" id="Path" />
          <path d="M2.98,14.45 L2.98,0.65" id="Path" />
        </g>
      </g>
    </BaseSvgIcon>
  )
}

export default styled(Sort)``
